// import React, { useRef } from "react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import "./BrowsePropertyType.css";

// const propertyTypes = [
//   {
//     icon: "fas fa-hotel",
//     label: "Hotels",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/max1024x768/482484848.jpg?k=8a4a6a208df51e019f9b12da6c2c7f5b7f1b82a1da24302d5dfe32b39b78c497&o=",
//   },
//   {
//     icon: "fas fa-building",
//     label: "Apartments",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/max1024x768/479349914.jpg?k=38b1de3ec179a50a2c040f67d4c3d5c39866e0df35203e7c7d0c4c931a3d7d5f&o=",
//   },
//   {
//     icon: "fas fa-umbrella-beach",
//     label: "Resorts",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/max1024x768/496228182.jpg?k=561cc4e31bcb4b7a0e176a4956d3c68cbcd402b819cd38cb8ad7671c7b85dc9a&o=",
//   },
//   {
//     icon: "fas fa-home",
//     label: "Villas",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/max1024x768/479349914.jpg?k=23b5a05ec9e2cbfd35051c19aa6b8c7fddf13aa708d77aef7d6e392db83f4ac1&o=",
//   },
// ];

// const BrowsePropertyType = () => {
//   const scrollRef = useRef(null);

//   const scroll = (direction) => {
//     if (direction === "left") {
//       scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
//     } else {
//       scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
//     }
//   };

//   return (
//     <div className="property-container">
//       <h2 className="property-title">Browse by property type</h2>

//       <div className="scroll-wrapper">
//         <button className="scroll-btn left" onClick={() => scroll("left")}>
//           <FaChevronLeft />
//         </button>

//         <div className="property-scroll" ref={scrollRef}>
//           {propertyTypes.map((item, index) => (
//             <div className="property-card" key={index}>
//               <img src={item.image} alt={item.label} />
//               <h3>{item.label}</h3>
//             </div>
//           ))}
//         </div>

//         <button className="scroll-btn right" onClick={() => scroll("right")}>
//           <FaChevronRight />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default BrowsePropertyType;






import React, { useRef, useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./BrowsePropertyType.css";

import About1 from '../../img/hotel.jpg';
import About2 from '../../img/Apartments.jpg';
import About3 from '../../img/Home Stay.jpg';
import About4 from '../../img/Hostels.jpg';

const propertyTypes = [
  { label: "Hotel Stay", image: About1 },
  { label: "Apartment Stay", image: About2 },
  { label: "Home Stay", image: About3 },
  { label: "Hostels", image: About4 },
];

const BrowsePropertyType = () => {
  const scrollRef = useRef(null);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    if (scrollRef.current) {
      const shouldScroll =
        scrollRef.current.scrollWidth > scrollRef.current.clientWidth;
      setShowScroll(shouldScroll);
    }
  }, []);

  const scroll = (direction) => {
    if (direction === "left") {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    } else {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <div className="BrowsePropertyType">
      <h2 className="BrowsePropertyType__title">Browse by property type</h2>

      <div className="BrowsePropertyType__wrapper">
        {showScroll && (
          <button
            className="BrowsePropertyType__btn BrowsePropertyType__btn--left"
            onClick={() => scroll("left")}
          >
            <FaChevronLeft />
          </button>
        )}

        <div className="BrowsePropertyType__scroll" ref={scrollRef}>
          {propertyTypes.map((item, index) => (
            <div className="BrowsePropertyType__card" key={index}>
              <img src={item.image} alt={item.label} />
              <h3>{item.label}</h3>
            </div>
          ))}
        </div>

        {showScroll && (
          <button
            className="BrowsePropertyType__btn BrowsePropertyType__btn--right"
            onClick={() => scroll("right")}
          >
            <FaChevronRight />
          </button>
        )}
      </div>
    </div>
  );
};

export default BrowsePropertyType;
